export enum nlCartiqoLayersEnum {
    parcels = 'parcels',
    buildings = 'buildings',
    trees = 'trees',
    zones = 'zones',
    dimensions = 'dimensions',
}